<template>
  <div
    v-if="activeDialog"
    class="overlay"
    :class="activeDialog ? 'active': ''"
  >
    <div
      id="dialog_close"
      class="common-dialog-wrapper"
      :class="customClass"
    >
      <div class="close-dialog" @click="activeDialog = false">
        <GreyCloseIcon20 />
      </div>
      <h2 class="service-message-title">
        {{ title }}
      </h2>
      <h3>
        {{ subtitle }}
      </h3>
      <p class="service-message-description">
        {{ text }}
      </p>
      <div class="popup-btn-wrapper">
        <button
          class="btn dialog-btn btn-revert"
          @click="closePopup"
        >
          Cancel
        </button>
        <button
          class="btn"
          @click="onConfirm"
        >
          {{ confirmBtnText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import GreyCloseIcon20 from '@/components/icons/GreyCloseIcon20.vue';

export default {
  name: 'InfoDialog',
  components: {GreyCloseIcon20},
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      required: true,
    },
    confirmBtnText: {
      type: String,
      required: true,
    },
    cancelBtnText: {
      type: String,
      default: 'Cancel'
    },
    showFooter: {
      type: Boolean
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    },
  },

  data() {
    return {
      activeDialog: false,
      paylod: null
    };
  },
  methods: {
    openPopup(payload) {
      this.paylod = payload;
      this.activeDialog = true;
    },
    closePopup() {
      this.activeDialog = false;
    },
    onConfirm() {
      this.activeDialog = false;
      this.$emit('onConfirm', this.paylod);
    }
  }
};
</script>

<style>
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.overlay.active {
  animation: show .3s linear;
}

.common-dialog-wrapper {
  width: 100%;
  max-width: 590px;
  border: 1px solid #D7DCE6;
  box-sizing: border-box;
  border-radius: 30px;
  padding: 40px 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
}

.close-dialog {
  width: 70px;
  height: 70px;
  padding: 23px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.close-dialog svg {
  width: 100%;
  height: 100%;
}

.close-dialog svg path {
  transition: .5s all;
}

.close-dialog:hover svg path {
  fill: var(--accent-color);
}

.close-dialog img {
  display: block;
  width: 100%;
}

.btn {
  width: 100%;
  max-width: 215px;
}

.common-dialog-wrapper .dialog-btn {
  min-width: 150px;
  width: 100%;
  max-width: 215px;
  padding: 13px 12px;
  background-color: var(--white-color);
  border-color: var(--accent-color);
}

.common-dialog-wrapper .dialog-btn:hover {
  background-color: var(--accent-color);
  border-color: var(--accent-color);
}

.common-dialog-wrapper .dialog-btn:hover .dialog-btn-text {
  color: var(--white-color);
}

.dialog-btn-text {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: var(--accent-color);
  transition: .5s all;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}

/*custom classes */
.common-dialog-wrapper.assign-success {
  width: 100%;
  max-width: 588px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.popup-btn-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-around;
  margin-top: 30px;
}

</style>
